import Image from 'next/image'
import { FC, useCallback, useEffect } from 'react'

import { Trans } from 'react-i18next'
import { useTranslation } from '../../../../hooks/useTranslation'
import SECTION_RIGHT from '../assets/img/introduce_bg.png'
import SECTION_RIGHT_VN from '../assets/img/introduce_bg_vn.png'
import SECTION_RIGHT_MOBILE from '../assets/img/introduce_bg_mobile.png'
import SECTION_RIGHT_VN_MOBILE from '../assets/img/introduce_bg_vn_mobile.png'
import IMAGE_GROUP_LEFT from '../assets/img/introduce_group_left.png'
import IMAGE_GROUP_RIGHT from '../assets/img/introduce_group_right.png'
import IMAGE_GROUP_TOP from '../assets/img/introduce_group_top.png'
// import { LINK_URL_EMPLOYER_CONTACT } from '../../../../utillities/LinkURL'
import useMixpanel from '../../../../hooks/useMixpanel'
import { registerClickOnContactButton, unregisterClickOnContactButton } from '../../../../pages/employer/headhunt-service/headhunt-service'
// import LinkWrapper from '../../../../components/Link'

const SectionIntroduceHH: FC<{ contactRef?; setIsLazyLoading?; getRef?; getRefMobile? }> = ({ setIsLazyLoading, getRef, getRefMobile }) => {
  const { translate, currentLanguage } = useTranslation()
  const Mixpanel = useMixpanel()

  const handleScrollToSection = useCallback(() => {
    // console.log(contactRef.current)
    setIsLazyLoading(false)
    return Promise.all([
      getRef()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      }),

      getRefMobile()?.then((targetRef) => {
        targetRef?.current?.scrollIntoView()
      })
    ]).then(() => {
      return
    })
  }, [])

  useEffect(() => {
    registerClickOnContactButton(handleScrollToSection)
    return () => {
      unregisterClickOnContactButton(handleScrollToSection)
    }
  }, [])

  return (
    <div className="introduce">
      <div className="image-group-top">
        <Image src={IMAGE_GROUP_TOP} alt="image_2" width={488} height={161} />
      </div>
      <div className="image-group-left">
        <Image src={IMAGE_GROUP_LEFT} alt="image_2" width={456} height={924} />
      </div>
      <div className="image-group-right">
        <Image src={IMAGE_GROUP_RIGHT} alt="image_2" width={384} height={998} />
      </div>
      <div className="introduce_blur_center" />
      <div className="introduce_blur_bottom" />
      <div className="wrapper-container">
        <div className="section-left">
          <h1 className="title">
            <Trans i18nKey="page_employer_headhunt_service:lp_the_first_headhunting" values={{ value: 'AI' }}>
              <span className="high-light"></span>
              <br />
            </Trans>
          </h1>

          <h2 className="sub-title">
            <Trans i18nKey="page_employer_headhunt_service:lp_find_your_high_quality">
              <br />
            </Trans>
          </h2>
          {/* <LinkWrapper hardReload prefetch={false} href={LINK_URL_EMPLOYER_CONTACT}> */}
          <div className="text-center">
            <a
              id="button_book_a_consultation_1"
              data-mixpanel-event={Mixpanel.EVENTS.CLICK_BOOK_A_CONSULTANT}
              className="btn-book-consultation"
              onClick={() => handleScrollToSection()}>
              {translate('page_employer_headhunt_service:lp_book_a_consultation')}
            </a>
          </div>
        </div>

        <div className="section-right">
          <div className="introduce-blur-mobile" />
          <div className="d-desktop">
            <Image
              src={currentLanguage === 'en' ? SECTION_RIGHT : SECTION_RIGHT_VN}
              placeholder="blur"
              alt="img_right"
              width={1442}
              height={557}
            />
          </div>

          <div className="d-mobile introduce-bg-mobile">
            <Image
              src={currentLanguage === 'en' ? SECTION_RIGHT_MOBILE : SECTION_RIGHT_VN_MOBILE}
              placeholder="blur"
              alt="img_right"
              width={341}
              height={398}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionIntroduceHH
